import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Earth } from '../../../../assets/icons/earth.svg'
import { ReactComponent as Pencil } from '../../../../assets/icons/pencil.svg'
import { ReactComponent as Delete } from '../../../../assets/icons/trash.svg'
import {
    ConditionNameEnum,
    IResponseContent,
    useResponsesStore,
} from '../../../../stores/responsesStore'
import SanitizeHTML from '../../../SanitizeHTML/SanitizeHTML'

import EditMessage from './EditMessage'

import styles from './message.module.scss'

interface IMessageProps {
    message: IResponseContent
}

function Message(props: IMessageProps) {
    const { message } = props
    const { text, image, _id } = props.message

    const { t } = useTranslation()

    const [, { deleteResponseContent }] = useResponsesStore()

    const [isEditing, setIsEditing] = useState(false)

    const handleEditMessage = () => {
        setIsEditing(true)
    }

    const handleDeleteMessage = () => {
        _id && deleteResponseContent(_id)
    }

    const language = message?.condition?.find(
        (condition) => condition.name === ConditionNameEnum.LANGUAGE
    )?.value

    return (
        <div className={styles.message}>
            {!isEditing ? (
                <>
                    <div className={styles.message__content}>
                        {text ? (
                            <SanitizeHTML
                                className={styles.message__text}
                                html={text
                                    .replaceAll('{', '{<b>')
                                    .replaceAll('}', '</b>}')}
                            />
                        ) : null}
                        {image ? (
                            <img
                                className={styles.message__image}
                                src={image}
                                alt=""
                            />
                        ) : null}
                    </div>
                    <div className={styles.message__buttons}>
                        {language ? (
                            <div className={styles.message__language}>
                                <Earth
                                    className={styles.message__languageIcon}
                                />

                                <div className={styles.message__languageText}>
                                    {language}
                                </div>
                            </div>
                        ) : null}
                        <button
                            className={styles.message__btn}
                            onClick={handleEditMessage}
                        >
                            <Pencil
                                className={styles.message__icon}
                                alt={t('edit')}
                            />
                        </button>
                        <button
                            className={styles.message__btn}
                            onClick={handleDeleteMessage}
                        >
                            <Delete
                                className={styles.message__icon}
                                alt={t('delete')}
                            />
                        </button>
                    </div>
                </>
            ) : (
                <EditMessage message={message} setIsEditing={setIsEditing} />
            )}
        </div>
    )
}

export default Message
